<app-comparison [chartType]="'xr'"></app-comparison>